
import HomeOne from './pages/HomeOne';
import Contact from './pages/Contact';

// add new pages for icis 2022

import Topic from './pages/Topic';
import Competition from './pages/Competition';
import CompetitionResult from './pages/CompetitionResult';
import Submission from './pages/Submission';
import Deadlines from './pages/Deadlines';
import SpecialSession from './pages/SpecialSession';
import Registration from './pages/Registration';
import RegistrationPub from './pages/RegistrationPub';
import Venue from './pages/Venue';
import Transportation from './pages/Transportation';
import Accommodation from './pages/Accommodation';
import Scenery from './pages/Scenery';
import Scenery_zn from './pages/Scenery_zn';
import ReceptionBanquet from './pages/ReceptionBanquet';
import Visa from './pages/Visa';
import Program from './pages/Program';
import Proceeding from './pages/Proceeding';
import Sessions from './pages/Sessions';
import Speakers from './pages/Speakers';
import Tutorials from './pages/Tutorials';
import Symposia from './pages/Symposia';
import Committees from './pages/Committees';
import Sponsors from './pages/Sponsors';
import History from './pages/History';
import Pay from './pages/Pay';
import PayPub from './pages/PayPub';
import Paych from './pages/Paych';
import PaychPub from './pages/PaychPub';
import Form from './pages/Form';
import FormPub from './pages/FormPub';
import Upload from './pages/Upload';
import Verify from './pages/Verify';
import Reservation from './pages/Reservation';
// import Submission_zn from './pages/Submission_zn';
// import Competition_zn from './pages/Competition_zn';
// import Venue_zn from './pages/Venue_zn';
// import Transportation_zn from './pages/Transportation_zn';
// import Accommodation_zn from './pages/Accommodation_zn';
// import Scenery_zn from './pages/Scenery_zn';
// import ReceptionBanquet_zn from './pages/ReceptionBanquet_zn';
import PageNotFound from './pages/PageNotFound';
import Gallery from './pages/Gallery';
// import WorkDetails from './pages/WorkDetails';



export default [

  { path: `${process.env.PUBLIC_URL + "/"}`, name: "HomeOne", component: HomeOne },
  { path: `${process.env.PUBLIC_URL + "/gallery"}`, name: "Gallery", component: Gallery },
  { path: `${process.env.PUBLIC_URL + "/contact"}`, name: "Contact", component: Contact },
  { path: `${process.env.PUBLIC_URL + "/topic"}`, name: "Topic", component: Topic },
  { path: `${process.env.PUBLIC_URL + "/competition"}`, name: "Competition", component: Competition },
  { path: `${process.env.PUBLIC_URL + "/competition_result"}`, name: "CompetitionResult", component: CompetitionResult },
  { path: `${process.env.PUBLIC_URL + "/submission"}`, name: "Submission", component: Submission },
  { path: `${process.env.PUBLIC_URL + "/deadlines"}`, name: "Deadlines", component: Deadlines },
  { path: `${process.env.PUBLIC_URL + "/specialsession"}`, name: "SpecialSession", component: SpecialSession },
  { path: `${process.env.PUBLIC_URL + "/registration"}`, name: "Registration", component: Registration, auth: true },
  { path: `${process.env.PUBLIC_URL + "/registration_pub"}`, name: "RegistrationPub", component: RegistrationPub },
  { path: `${process.env.PUBLIC_URL + "/venue"}`, name: "Venue", component: Venue },
  { path: `${process.env.PUBLIC_URL + "/transportation"}`, name: "Transportation", component: Transportation },
  { path: `${process.env.PUBLIC_URL + "/accommodation"}`, name: "Accommodation", component: Accommodation },
  { path: `${process.env.PUBLIC_URL + "/scenery"}`, name: "Scenery", component: Scenery },
  { path: `${process.env.PUBLIC_URL + "/scenery_zn"}`, name: "Scenery_zn", component: Scenery_zn },
  { path: `${process.env.PUBLIC_URL + "/receptionBanquet"}`, name: "ReceptionBanquet", component: ReceptionBanquet },
  { path: `${process.env.PUBLIC_URL + "/visa"}`, name: "Visa", component: Visa },
  { path: `${process.env.PUBLIC_URL + "/program"}`, name: "Program", component: Program },
  { path: `${process.env.PUBLIC_URL + "/proceeding"}`, name: "Proceeding", component: Proceeding },
  { path: `${process.env.PUBLIC_URL + "/sessions"}`, name: "Sessions", component: Sessions },
  { path: `${process.env.PUBLIC_URL + "/speakers"}`, name: "Speakers", component: Speakers },
  { path: `${process.env.PUBLIC_URL + "/tutorials"}`, name: "Tutorials", component: Tutorials },
  { path: `${process.env.PUBLIC_URL + "/symposia"}`, name: "Symposia", component: Symposia },
  { path: `${process.env.PUBLIC_URL + "/committees"}`, name: "Committees", component: Committees },
  { path: `${process.env.PUBLIC_URL + "/sponsors"}`, name: "Sponsors", component: Sponsors },
  { path: `${process.env.PUBLIC_URL + "/history"}`, name: "History", component: History },
  { path: `${process.env.PUBLIC_URL + "/pay"}`, name: "Pay", component: Pay, auth: true },
  { path: `${process.env.PUBLIC_URL + "/pay_pub"}`, name: "PayPub", component: PayPub },
  { path: `${process.env.PUBLIC_URL + "/paych"}`, name: "Paych", component: Paych, auth: true },
  { path: `${process.env.PUBLIC_URL + "/paych_pub"}`, name: "PaychPub", component: PaychPub },
  { path: `${process.env.PUBLIC_URL + "/form"}`, name: "Form", component: Form, auth: true },
  { path: `${process.env.PUBLIC_URL + "/form_pub"}`, name: "FormPub", component: FormPub },
  { path: `${process.env.PUBLIC_URL + "/upload"}`, name: "Upload", component: Upload, auth: true },
  { path: `${process.env.PUBLIC_URL + "/verify"}`, name: "Verify", component: Verify },
  { path: `${process.env.PUBLIC_URL + "/reservation"}`, name: "Reservation", component: Reservation },
  // { path: `${process.env.PUBLIC_URL + "/submission_zn"}`, name: "Submission_zn", component: Submission_zn },
  // { path: `${process.env.PUBLIC_URL + "/competition_zn"}`, name: "Competition_zn", component: Competition_zn },
  // { path: `${process.env.PUBLIC_URL + "/venue_zn"}`, name: "Venue_zn", component: Venue_zn },
  // { path: `${process.env.PUBLIC_URL + "/transportation_zn"}`, name: "Transportation_zn", component: Transportation_zn },
  // { path: `${process.env.PUBLIC_URL + "/accommodation_zn"}`, name: "Accommodation_zn", component: Accommodation_zn },
  // { path: `${process.env.PUBLIC_URL + "/scenery_zn"}`, name: "Scenery_zn", component: Scenery_zn },
  // { path: `${process.env.PUBLIC_URL + "/receptionbanquet_zn"}`, name: "ReceptionBanquet_zn", component: ReceptionBanquet_zn },
  { path: `${process.env.PUBLIC_URL + "/404"}`, name: "PageNotFound", component: PageNotFound },


];




